import src from "IMAGE";
export default { src, width: 507, height: 368, blurWidth: 0, blurHeight: 0};
